<template>
    <div style="position: relative;left: 0;top: 0;bottom: 0;right: 0;width:100%;" v-loading.fullscreen.lock="fullscreenLoading">
        <div class="left-head">
            <el-row>
                <el-col :span="24">用户列表</el-col>
            </el-row>
        </div>
        <div class="left">
            <div class="left-top">
                <el-input v-model="filterText" size="small">
                    <template slot="prepend">用户名称/编号</template>
                </el-input>
            </div>
            <div class="left-middle">
                <el-radio-group v-model="meterType" size="mini" :disabled="unitLoading">
                    <el-radio-button label="2">电表</el-radio-button>
                    <el-radio-button label="1">水表</el-radio-button>
                </el-radio-group>
            </div>
            <div class="left-bottom">
                <el-tree
                        style="background-color: #fafafa"
                        class="filter-tree"
                        :data="energyUnit"
                        :props="defaultProps"
                        :default-expanded-keys="expandKeys"
                        :highlight-current="true"
                        v-loading="unitLoading"
                        node-key="id"
                        :filter-node-method="filterNode"
                        :expand-on-click-node="false"
                        ref="energyUnitRef"
                        :indent="fontSize"
                        @node-click="unitClick">
                </el-tree>
            </div>
        </div>
        <div class="right-head">
            <el-row>
                <el-col :span="24">综合统计</el-col>
            </el-row>
        </div>
        <div class="right">
            <div class="right-top">
                <div class="card-a">
                    <div class="card-left">
                        <div class="card-right-flex">
                            <svg-icon icon-class="累计充值成功"></svg-icon>
                        </div>
                    </div>
                    <div class="card-right">
                        <div class="card-right-flex">
                        <div class="card-right-top">
                            <span v-text="totalDataNumber"></span>
                            <span v-text="energyUnitText" class="card-right-top-unit">kWh</span>
                        </div>
                        <div class="card-right-bottom">
                            累计能耗量
                        </div>
                        </div>
                    </div>
                </div>
                <div class="card-b">
                    <div class="card-left">
                        <div class="card-right-flex">
                            <svg-icon icon-class="累计充值成功"></svg-icon>
                        </div>
                    </div>
                    <div class="card-right">
                        <div class="card-right-flex">
                        <div class="card-right-top">
                            <span v-text="totalRechargeCount"></span>
                            <span class="card-right-top-unit">次</span>
                        </div>
                        <div class="card-right-bottom">
                            累计充值成功次数
                        </div>
                        </div>
                    </div>
                </div>
                <div class="card-c">
                    <div class="card-left">
                        <div class="card-right-flex">
                            <svg-icon icon-class="累计充值金额"></svg-icon>
                        </div>
                    </div>
                    <div class="card-right">
                        <div class="card-right-flex">
                        <div class="card-right-top">
                            <span v-text="totalRecharge"></span>
                            <span class="card-right-top-unit">元</span>
                        </div>
                        <div class="card-right-bottom">
                            累计充值金额
                        </div>
                        </div>
                    </div>
                </div>
                <div class="card-d">
                    <div class="card-left">
                        <div class="card-right-flex">
                            <svg-icon icon-class="累计充值金额"></svg-icon>
                        </div>
                    </div>
                    <div class="card-right">
                        <div class="card-right-flex">
                        <div class="card-right-top">
                            <span v-text="totalConsumption"></span>
                            <span class="card-right-top-unit">元</span>
                        </div>
                        <div class="card-right-bottom">
                            累计消费金额
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="right-bottom-head">
                <span style="font-size: 0.9375rem;font-weight: 600;line-height: 2.5rem;">综合明细</span>
                <span style="position: absolute;right: 30%;">
                    <el-radio-group v-model="timePeriod" size="mini" :disabled="tableLoading">
                            <el-radio-button label="day">日</el-radio-button>
                            <el-radio-button label="week">周</el-radio-button>
                            <el-radio-button label="month">月</el-radio-button>
                            <el-radio-button label="year">年</el-radio-button>
                        </el-radio-group>
                </span>
                <span style="position: absolute;right: 1%;">
                    <el-date-picker
                            :disabled="tableLoading"
                            size="small"
                            v-model="dateInterval"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                        </el-date-picker>
                </span>
            </div>
            <div class="right-bottom" v-loading="tableLoading">
                <div style="width: 99.8%;height:calc(100% - 2rem);">
                    <flex>
                    <el-table
                            :data="tableData"
                            stripe
                            size="mini"
                            height="100%"
                            style="width: 100%">
                        <el-table-column type="expand">
                            <template slot-scope="props">
                                <el-form label-position="left" inline class="synthetic-table-expand">
                                    <el-form-item label="用户编号:">
                                        <span>{{ props.row.customerusercode | tableStringFormat }}</span>
                                    </el-form-item>
                                    <el-form-item label="仪表编号:">
                                        <span>{{ props.row.metercode | tableStringFormat }}</span>
                                    </el-form-item>
                                    <el-form-item label="表号:">
                                        <span>{{ props.row.meternum | tableStringFormat }}</span>
                                    </el-form-item>
                                    <el-form-item label="充值次数:">
                                        <span>{{ props.row.rechargecount | tableCountFormat }}</span>
                                    </el-form-item>
                                    <el-form-item label="充值金额（元）:">
                                        <span>{{ props.row.rechargeamount | tableNumberFormat }}</span>
                                    </el-form-item>
                                    <el-form-item label="消费金额（元）:">
                                        <span>{{ props.row.consumeamount | tableNumberFormat }}</span>
                                    </el-form-item>
                                    <el-form-item label="备注:">
                                        <span>{{ props.row.meterremark | tableStringFormat }}</span>
                                    </el-form-item>
                                </el-form>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="序号"
                                width="60">
                            <template scope="scope"><span>{{scope.$index+(currentPage - 1) * pageSize + 1}} </span></template>
                        </el-table-column>
                        <el-table-column
                                prop="customerusername"
                                label="用户名称"
                                :formatter="tableStringFormat">
                        </el-table-column>
                        <el-table-column
                                prop="metername"
                                label="仪表名称"
                                :formatter="tableStringFormat">
                        </el-table-column>
                        <el-table-column
                                prop="starttime"
                                label="起始时间"
                                :formatter="tableTimeFormat">
                        </el-table-column>
                        <el-table-column
                                prop="endtime"
                                label="截止时间"
                                :formatter="tableTimeFormat">
                        </el-table-column>
                        <el-table-column
                                prop="startenergydata"
                                :label="tableStartEnergyData"
                                :formatter="tableNumberFormat">
                        </el-table-column>
                        <el-table-column
                                prop="endenergydata"
                                :label="tableEndEnergyData"
                                :formatter="tableNumberFormat">
                        </el-table-column>
                        <el-table-column
                                prop="energydata"
                                :label="tableEnergyData"
                                :formatter="tableNumberFormat">
                        </el-table-column>
                        <el-table-column
                                prop="startbalance"
                                label="期初余额（元）"
                                :formatter="tableNumberFormat">
                        </el-table-column>
                        <el-table-column
                                prop="endbalance"
                                label="期末余额（元）"
                                :formatter="tableNumberFormat">
                        </el-table-column>
                    </el-table>
                    </flex>
                </div>
                <div style="width: 100%;height:2rem;">
                    <div style="width: 80%;height:2rem;text-align: center;float: left;">
                        <el-pagination
                                background
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="currentPage"
                                :page-sizes="[10, 20, 30, 50, 100]"
                                :page-size="pageSize"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="pageTotal">
                        </el-pagination>
                    </div>
                    <div style="width: 20%;height:2rem;text-align: center;float:right;">
                        <el-button style="height:1.75rem;float:right;margin-top: 0.125rem;" size="mini" @click="exportClick">数据导出</el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import { totalRechargeCount,totalRecharge } from '@/api/rechargeRecord'
  import { syntheticReport } from '@/api/Meter'
  import { tree, expandedCustomerWithMeter } from '@/utils/energyUtilTree'
  import { getStartAndEnd,format } from '@/utils/time'
  import { comdify } from '@/utils/numberUtil'
  import { exportExcel } from '@/utils/excelUtil'
  import Flex from '@/components/Flex'
  import {mapGetters} from 'vuex'
  export default {
    name: 'syntheticReport',
    components: {
      'flex': Flex
    },
    data() {
      return {
        filterText: '',
        energyUnit: [],
        meterType:"2",
        timePeriod:"month",
        dateInterval:[],
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        unitLoading:false,
        tableData:[],
        tableDataAll:[],
        currentPage:1,
        pageSize:100,
        pageTotal:0,
        meterIds:[],
        meterIdsTemp:[],
        channelFilter:[],
        typeFilter:[],
        channelFilterTemp:[],
        typeFilterTemp:[],
        totalDataNumber:0,
        totalRechargeCount:0,
        totalRecharge:0,
        totalConsumption:0,
        fullscreenLoading: false,
        tableLoading:false,
        energyUnitText:"kWh",
        tableStartEnergyData:"期初表底数（kWh）",
        tableEndEnergyData:"期末表底数（kWh）",
        tableEnergyData:"能耗量（kWh）",
        expandKeys: []
      };
    },
    watch: {
      filterText(val) { //过滤能耗单元树
        this.$refs.energyUnitRef.filter(val);
      },
      meterType(val){ //监听能源类型变化
        this.filterText=""
        if(val==="2"){
          this.energyUnitText="kWh"
          this.tableStartEnergyData="期初表底数（kWh）"
          this.tableEndEnergyData="期末表底数（kWh）"
          this.tableEnergyData="能耗量（kWh）"
        }else if(val==="1"){
          this.energyUnitText="m³"
          this.tableStartEnergyData="期初表底数（m³）"
          this.tableEndEnergyData="期末表底数（m³）"
          this.tableEnergyData="能耗量（m³）"
        }
        this.selectEnergyUnit()
      },
      timePeriod(val){  //监听时间区间变化
        if(val!==null){
          //时间框置空
          this.dateInterval=null
          if(this.meterIds.length !== 0){
            this.getTableData()
          }
        }
      },
      meterIds(val){    //监听仪表id变化
        if(val && val.length > 0) {
          this.getTableData()
        }
      },
      dateInterval(val){    //监听时间框变化
        if(val!==null){
          //时间区间置空
          this.timePeriod=null
          if(this.meterIds.length !== 0){
            this.getTableData()
          }
        }
      }
    },
    mounted() {
      this.selectEnergyUnit()
    },
    computed: {
      ...mapGetters([
        'fontSize'
      ])
    },
    filters:{
      tableStringFormat(val){   //表格中字符串格式化
        if(val!==null&&val!==undefined&&val!==""){
          return val
        }
        return "--"
      },
      tableNumberFormat(val){   //表格中数字格式化
        if(val!==null&&val!==undefined&&val!==""){
          return val.toFixed(2)
        }
        return "--"
      },
      tableCountFormat(val){
        if(val!==null&&val!==undefined&&val!==""){
          return val
        }
        return 0
      }
    },
    methods: {
      filterNode(value, data) { //过滤能耗单元树
        let flag=false;
        if (!value){
          flag=true;
        }else{
          if(data.type===1){ // 1 是用户
            if(data.label!==null&&data.label.indexOf(value) !== -1){
              flag=true;
            }else if(data.code!==null&&data.code.indexOf(value) !== -1){
              flag=true;
            }else{
              flag=false
            }
          }
          if(data.type===2){ // 2 是仪表
            if(data.father.name!==null&&data.father.name.indexOf(value) !== -1){
              flag=true;
            }else if(data.father.code!==null&&data.father.code.indexOf(value) !== -1){
              flag=true;
            }else{
              flag=false
            }
          }
        }
        return flag;
      },
      selectEnergyUnit() {  // 查询能耗单元树
        this.unitLoading=true;
        const customerId = this.$store.getters.customerId
        tree(customerId,null,null,this.meterType,1).then(response => {
          debugger
          this.unitLoading = false
          this.energyUnit = response[0].children
          // 设置默认展开
          for(let i in this.energyUnit){
            let energy = this.energyUnit[i]
            if(energy !== null && energy !== undefined && energy.type !== 2){
              this.expandKeys.push(energy.id)
              for(let j in energy.children){
                let child = energy.children[j]
                if(child !== null && child !== undefined && child.type !== 2){
                  this.expandKeys.push(child.id)
                }
              }
            }
          }
          // 选中第一个用户
          const keys = expandedCustomerWithMeter(this.energyUnit)
          if (keys != undefined) {
            this.$nextTick(() => {
              this.$refs.energyUnitRef.setCurrentKey(keys[0].customerId)
            })
            // 获取当前用户下所有仪表id
            this.meterIds=keys[1].meterId
          }
        }).catch(error => {
          this.unitLoading = false
          this.$message({
            type: 'error',
            message: '能耗单元查询失败'
          })
        })
      },
      unitClick(data, node) { //点击能耗单元
        //获取点击节点下的所有仪表id
        this.meterIds=[]
        this.meterIdsTemp=[]
        this.getMeterIds(data)
        this.meterIds=this.meterIdsTemp
      },
      tableTimeFormat(row, column, cellValue){   //表格中时间格式化
        if(cellValue!==null&&cellValue!==undefined&&cellValue!==""){
          return format(cellValue,"YYYY-MM-DD HH:mm:ss")
        }
        return "--"

      },
      tableStringFormat(row, column, cellValue){   //表格中字符串格式化
        if(cellValue!==null&&cellValue!==undefined&&cellValue!==""){
          return cellValue
        }
        return "--"
      },
      tableNumberFormat(row, column, cellValue){   //表格中数字格式化
        if(cellValue!==null&&cellValue!==undefined&&cellValue!==""){
          return cellValue.toFixed(2)
        }
        return "--"
      },
      handleSizeChange(val) {   //每页显示条数改变
        this.pageSize=val
        if(this.currentPage<=(parseInt((this.pageTotal-1)/this.pageSize)+1)){   //防止重复分页
          this.page()
        }
      },
      handleCurrentChange(val) {    //当前页数改变
        this.currentPage=val
        this.page()
      },
      getMeterIds(val){    //获取所有子节点的仪表id
        if(val.type===2){
          this.meterIdsTemp.push(val.typeId)
        }
        if(val.children!==undefined&&val.children!==null){
          for(let i in val.children){
            this.getMeterIds(val.children[i])
          }
        }
      },
      getTableData(){    //数据表格查询，综合统计查询
        let startTime=null
        let endTime=null
        let timeGranularity=null
        let customerId = this.$store.getters.customerId
        if(this.dateInterval!==null&&this.dateInterval.length!==0){  //时间框不为空使用时间框中的时间
          startTime=format(this.dateInterval[0],"YYYY-MM-DD HH:mm:ss")
          endTime=format(this.dateInterval[1],"YYYY-MM-DD HH:mm:ss")
          endTime=endTime.replace("00:00:00","23:59:59")
          timeGranularity="day"
        }else if(this.timePeriod!==null){  //时间区间不为空则使用时间区间的时间
          let timeJson=getStartAndEnd("now",this.timePeriod)
          startTime=format(timeJson.start,"YYYY-MM-DD HH:mm:ss")
          endTime=format(timeJson.end,"YYYY-MM-DD HH:mm:ss")
          timeGranularity=this.timePeriod
        }else{  //都为空则为异常
          this.$message({
            type: 'error',
            message: '请选择查询时间'
          })
          return
        }
        //查询数据表格
        this.tableLoading=true
        this.unitLoading=true
        syntheticReport(this.meterIds,startTime,endTime,timeGranularity,customerId).then(response => {
          if(response.infoJson!==null){
            this.totalDataNumber=0
            this.totalConsumption=0
            this.tableDataAll= response.infoJson
            this.currentPage=1
            this.pageTotal=this.tableDataAll.length
            this.tableData=this.tableDataAll.slice(0,this.pageSize)
            //计算累计能耗量和累计消费金额
            for(let i in this.tableDataAll){
              let energydata=this.tableDataAll[i]["energydata"]
              let consumeamount=this.tableDataAll[i]["consumeamount"]
              if(energydata!==null&&energydata!==undefined&&energydata!==""){
                this.totalDataNumber=this.totalDataNumber+parseFloat(energydata)
              }
              if(consumeamount!==null&&consumeamount!==undefined&&consumeamount!==""){
                this.totalConsumption=this.totalConsumption+parseFloat(consumeamount)
              }
            }
            this.totalConsumption=comdify(this.totalConsumption.toFixed(2))
            this.totalDataNumber=comdify(this.totalDataNumber.toFixed(2))
          }else{
            this.totalDataNumber=0
            this.totalConsumption=0
            this.tableDataAll=null
            this.currentPage=1
            this.pageTotal=0
            this.tableData=null
          }
          this.tableLoading=false
          this.unitLoading=false
        }).catch(error => {
          this.tableLoading=false
          this.unitLoading=false
          this.totalDataNumber=0
          this.totalConsumption=0
          this.$message({
            type: 'error',
            message: '数据表格查询失败'
          })
        })
        //查询累计充值成功次数
        totalRechargeCount(this.meterIds,startTime,endTime,this.channelFilterTemp,this.typeFilterTemp,2).then(response => {
          if(response.infoJson==null){
            this.totalRechargeCount=0
          }else{
            this.totalRechargeCount=comdify(response.infoJson)
          }
        }).catch(error => {
          this.totalRechargeCount=0
          this.$message({
            type: 'error',
            message: '累计充值成功次数查询失败'
          })
        })
        //查询累计充值金额
        totalRecharge(this.meterIds,startTime,endTime,this.channelFilterTemp,this.typeFilterTemp,2).then(response => {
          if(response.infoJson==null){
            this.totalRecharge=0
          }else{
            this.totalRecharge=comdify(response.infoJson.toFixed(2))
          }
        }).catch(error => {
          this.totalRecharge=0
          this.$message({
            type: 'error',
            message: '累计充值金额查询失败'
          })
        })
      },
      page(){   //逻辑分页
        this.tableData=this.tableDataAll.slice((this.currentPage-1)*this.pageSize,this.currentPage*this.pageSize)
      },
      exportClick(){    //点击数据导出
        let fileName="综合统计报表"
        let sheetName="综合统计报表"
        let dataTemp=this.tableDataAll
        let data=[]
        this.fullscreenLoading=true
        //整理excel数据
        for(let i in dataTemp){
          let map={}
          if(dataTemp[i].customerusername!==null&&dataTemp[i].customerusername!==undefined&&dataTemp[i].customerusername!==""){
            map["用户名称"]=dataTemp[i].customerusername
          }else{
            map["用户名称"]="--"
          }
          if(dataTemp[i].customerusercode!==null&&dataTemp[i].customerusercode!==undefined&&dataTemp[i].customerusercode!==""){
            map["用户编号"]=dataTemp[i].customerusercode
          }else{
            map["用户编号"]="--"
          }
          if(dataTemp[i].metername!==null&&dataTemp[i].metername!==undefined&&dataTemp[i].metername!==""){
            map["仪表名称"]=dataTemp[i].metername
          }else{
            map["仪表名称"]="--"
          }
          if(dataTemp[i].metercode!==null&&dataTemp[i].metercode!==undefined&&dataTemp[i].metercode!==""){
            map["仪表编号"]=dataTemp[i].metercode
          }else{
            map["仪表编号"]="--"
          }
          if(dataTemp[i].meternum!==null&&dataTemp[i].meternum!==undefined&&dataTemp[i].meternum!==""){
            map["表号"]=dataTemp[i].meternum+""
          }else{
            map["表号"]="--"
          }
          if(dataTemp[i].starttime!==null&&dataTemp[i].starttime!==undefined&&dataTemp[i].starttime!==""){
            map["起始时间"]=format(dataTemp[i].starttime,"YYYY-MM-DD HH:mm:ss")
          }else{
            map["起始时间"]="--"
          }
          if(dataTemp[i].endtime!==null&&dataTemp[i].endtime!==undefined&&dataTemp[i].endtime!==""){
            map["截止时间"]=format(dataTemp[i].endtime,"YYYY-MM-DD HH:mm:ss")
          }else{
            map["截止时间"]="--"
          }
          if(dataTemp[i].startenergydata!==null&&dataTemp[i].startenergydata!==undefined&&dataTemp[i].startenergydata!==""){
            map["期初表底数（"+this.energyUnitText+"）"]=dataTemp[i].startenergydata.toFixed(2)
          }else{
            map["期初表底数（"+this.energyUnitText+"）"]="--"
          }
          if(dataTemp[i].endenergydata!==null&&dataTemp[i].endenergydata!==undefined&&dataTemp[i].endenergydata!==""){
            map["期末表底数（"+this.energyUnitText+"）"]=dataTemp[i].endenergydata.toFixed(2)
          }else{
            map["期末表底数（"+this.energyUnitText+"）"]="--"
          }
          if(dataTemp[i].energydata!==null&&dataTemp[i].energydata!==undefined&&dataTemp[i].energydata!==""){
            map["能耗量（"+this.energyUnitText+"）"]=dataTemp[i].energydata.toFixed(2)
          }else{
            map["能耗量（"+this.energyUnitText+"）"]="--"
          }
          if(dataTemp[i].startbalance!==null&&dataTemp[i].startbalance!==undefined&&dataTemp[i].startbalance!==""){
            map["期初余额（元）"]=dataTemp[i].startbalance.toFixed(2)
          }else{
            map["期初余额（元）"]="--"
          }
          if(dataTemp[i].endbalance!==null&&dataTemp[i].endbalance!==undefined&&dataTemp[i].endbalance!==""){
            map["期末余额（元）"]=dataTemp[i].endbalance.toFixed(2)
          }else{
            map["期末余额（元）"]="--"
          }
          if(dataTemp[i].rechargecount!==null&&dataTemp[i].rechargecount!==undefined&&dataTemp[i].rechargecount!==""){
            map["充值次数"]=dataTemp[i].rechargecount
          }else{
            map["充值次数"]=0
          }
          if(dataTemp[i].rechargeamount!==null&&dataTemp[i].rechargeamount!==undefined&&dataTemp[i].rechargeamount!==""){
            map["充值金额（元）"]=dataTemp[i].rechargeamount.toFixed(2)
          }else{
            map["充值金额（元）"]="--"
          }
          if(dataTemp[i].consumeamount!==null&&dataTemp[i].consumeamount!==undefined&&dataTemp[i].consumeamount!==""){
            map["消费金额（元）"]=dataTemp[i].consumeamount.toFixed(2)
          }else{
            map["消费金额（元）"]="--"
          }
          if(dataTemp[i].meterremark!==null&&dataTemp[i].meterremark!==undefined&&dataTemp[i].meterremark!==""){
            map["备注"]=dataTemp[i].meterremark
          }else{
            map["备注"]="--"
          }
          data.push(map)
        }
        //导出表格
        let result=exportExcel(data,fileName,sheetName)
        if(result===0){
          this.$message({
            type: 'error',
            message: '无待导出数据'
          })
        }else if(result===1){
          this.$message({
            type: 'error',
            message: '导出失败'
          })
        }
        this.fullscreenLoading=false
      }
    }
  }
</script>

<style scoped>
    .el-col{
        line-height: 40px;
    }
    .el-col-24{
        font-size: 15px;
        font-weight: 600;
    }
    .left-head{
        position: absolute;
        left: 0;
        width:20%;
        padding-left: 10px;
    }
    .right-head {
        position: absolute;
        left: 19%;
        width: 77%;
        padding-left: 10px;
    }
    .left{
        position: absolute;
        left: 0;
        top: 40px;
        bottom: 10px;
        width:16%;
        height:calc(100% - 50px);
        background-color: #ffffff;
        border-radius: 4px;
    }
    .right{
        position: absolute;
        left: 19%;
        top: 40px;
        bottom: 10px;
        width:81%;
        height:calc(100% - 50px);
        border-radius: 4px;
    }
    .right-top{
        position: absolute;
        top:0;
        height: 17%;
        width: 100%;
    }
    .right-bottom-head{
        position: absolute;
        bottom: calc(75% + 5px);
        width:100%;
        padding-left: 10px;
    }
    .right-bottom{
        position: absolute;
        bottom: 0;
        height: calc(75% + 10px);
        width: 100%;
        background-color: #ffffff;
        overflow: auto;
        border-radius: 4px;
    }
    .card-a{
        position: absolute;
        height: 90%;
        width: 23.25%;
        border-radius: 8px;
        background: linear-gradient(#018AFE, #4BD2FF);
        left: 0;
    }
    .card-b{
        position: absolute;
        height: 90%;
        width: 23.25%;
        border-radius: 8px;
        background: linear-gradient(#03C8D8, #0FD2F5);
        left: 25.25%;
    }
    .card-c{
        position: absolute;
        height: 90%;
        width: 23.25%;
        border-radius: 8px;
        background: linear-gradient(#018AFE, #4BD2FF);
        left: 50.5%;
    }
    .card-d{
        position: absolute;
        height: 90%;
        width: 23.25%;
        border-radius: 8px;
        background: linear-gradient(#F87C2A, #F8C538);
        left: 75.75%;
    }
    .card-left{
        position: absolute;
        left:0;
        height: 100%;
        width: 20%;
        background: rgba(255,255,255,0.2);
        border-radius: 8px;
        text-align: center;
    }
    .card-right{
        position: absolute;
        right:0;
        height: 100%;
        width: 80%;
        border-radius: 8px;
        text-align:center;
        color: #ffffff;
    }
    .left-top{
        width:90%;
        height:40px;
        padding:10px 5% 0 5%;
    }
    .left-middle{
        width:100%;
        height:40px;
        padding:5px 0;
        text-align: center;
        border-bottom: 1px #E5E6E6 solid;
    }
    .left-bottom{
        padding-top: 20px;
        padding-left: 20px;
        padding-right: 20px;
        height: calc(100% - 120px);
        overflow: auto;
    }
    .el-tree {
        min-width: 100%;
        display:inline-block;
    }
    .svg-icon{
        width: 50%;
        height: 50%;
    }
    .card-right-top{
        font-size: 20px;
        font-weight: 600;
    }
    .card-right-bottom{
        font-size: 12px;
        margin-top: 2px;
        color: #D9F4F8;
    }
    .card-right-top-unit{
        font-size: 12px;
        margin-left: 10px;
        color: #D9F4F8;
    }
    .card-right-flex{
        display: flex;
        flex-direction:column;
        height:100%;
        width: 100%;
        align-items:center;
        justify-content: center;
    }
    .synthetic-table-expand>.el-form-item {
        margin-right: 30px;
        margin-bottom: 0;
    }
</style>
<style>
    .synthetic-table-expand>.el-form-item>.el-form-item__label {
        font-size: 12px;
        font-weight: bold;
        color: #909399;
    }
    .synthetic-table-expand>.el-form-item>.el-form-item__content {
        font-size: 12px;
    }
</style>